import React from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';

import { SessionCheckFailed, SessionChecking, useServerSession } from '../../../session';

const DeepLinkInsightRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const insightId = searchParams.get('insightId');
  const shareCode = searchParams.get('shareCode');
  const session = useServerSession();

  if (!insightId) {
    return <Navigate to="/" replace />;
  }

  if (session.status === 'pending') {
    return <SessionChecking paused={session.paused} />;
  }

  if (session.status === 'failed') {
    return <SessionCheckFailed error={session.error} onRetry={session.retry} />;
  }

  if (session.status === 'signedIn') {
    return <Navigate to={`/insightList?insightId=${insightId}`} replace />;
  }

  const publicUrl = shareCode  ? `/shared/insight/${insightId}/${shareCode}` : `/shared/insight/${insightId}`;
  
  return <Navigate to={publicUrl} replace />;
};

export default DeepLinkInsightRedirect;
